/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plan_Pro_CtaInputs */

const en_pricing_plan_pro_cta = /** @type {(inputs: Pricing_Plan_Pro_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Pro Plan`)
};

const de_pricing_plan_pro_cta = /** @type {(inputs: Pricing_Plan_Pro_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro-Plan starten`)
};

const fr_pricing_plan_pro_cta = /** @type {(inputs: Pricing_Plan_Pro_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer le plan Pro`)
};

const es_pricing_plan_pro_cta = /** @type {(inputs: Pricing_Plan_Pro_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar plan Pro`)
};

const it_pricing_plan_pro_cta = /** @type {(inputs: Pricing_Plan_Pro_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia il piano Pro`)
};

const nl_pricing_plan_pro_cta = /** @type {(inputs: Pricing_Plan_Pro_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Pro-abonnement`)
};

const pl_pricing_plan_pro_cta = /** @type {(inputs: Pricing_Plan_Pro_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij plan Pro`)
};

const fi_pricing_plan_pro_cta = /** @type {(inputs: Pricing_Plan_Pro_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita Pro-suunnitelma`)
};

const da_pricing_plan_pro_cta = /** @type {(inputs: Pricing_Plan_Pro_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Pro-planen`)
};

const sv_pricing_plan_pro_cta = /** @type {(inputs: Pricing_Plan_Pro_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starta Proplan`)
};

/**
* | output |
* | --- |
* | "Start Pro Plan" |
*
* @param {Pricing_Plan_Pro_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_plan_pro_cta = /** @type {((inputs?: Pricing_Plan_Pro_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plan_Pro_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_plan_pro_cta(inputs)
	if (locale === "fr") return fr_pricing_plan_pro_cta(inputs)
	if (locale === "es") return es_pricing_plan_pro_cta(inputs)
	if (locale === "it") return it_pricing_plan_pro_cta(inputs)
	if (locale === "nl") return nl_pricing_plan_pro_cta(inputs)
	if (locale === "pl") return pl_pricing_plan_pro_cta(inputs)
	if (locale === "fi") return fi_pricing_plan_pro_cta(inputs)
	if (locale === "da") return da_pricing_plan_pro_cta(inputs)
	if (locale === "sv") return sv_pricing_plan_pro_cta(inputs)
	return en_pricing_plan_pro_cta(inputs)
});